import { Address, addressEqual } from 'nftx.js';
import useVaults from './useVaults';
import { useMemo } from 'react';

const useVault = ({
  vaultAddress,
  vaultId,
  slug,
}: {
  vaultId?: string;
  vaultAddress?: Address;
  slug?: string;
}) => {
  const { data: vaults, status, error } = useVaults();

  const vault = useMemo(() => {
    if (!vaultId && !vaultAddress && !slug) {
      return;
    }
    return vaults?.find((vault) => {
      if (vaultId) {
        return vault.vaultId === vaultId;
      }
      if (vaultAddress) {
        return addressEqual(vault.id, vaultAddress);
      }
      if (slug) {
        return vault.slug === slug;
      }
      return false;
    });
  }, [slug, vaultAddress, vaultId, vaults]);

  return { status, error, data: vault };
};

export default useVault;
